import React from 'react';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import style from './style.module.scss';

const ProductGuidesSkeleton = () => {
  return (
    <>
      <SkeletonBlock className={style.skeletonGuide} />
      <SkeletonBlock className={style.skeletonGuide} />
      <SkeletonBlock className={style.skeletonGuide} />
      <SkeletonBlock className={style.skeletonGuide} />
      <SkeletonBlock className={style.skeletonGuide} />
    </>
  );
};

export default ProductGuidesSkeleton;
